import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { colors } from '@roku-web-ui/rds-theme';

const DARK_TEXT_COLOR = '#0b001b';

export const NavActionButton = styled(Button)(({ theme }) => ({
  color: DARK_TEXT_COLOR,
  backgroundColor: 'transparent',
  borderRadius: '50px',
  boxShadow: 'none',
  fontWeight: 'normal',
  fontSize: '14px',
  padding: '4px 16px',
  border: 'none',
  cursor: 'pointer',
  '&:hover, &:focus, &.active': {
    backgroundColor: colors.grey[300],
    boxShadow: 'none',
    color: DARK_TEXT_COLOR,
  },
  '&.active': {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.getContrastText(theme.palette.primary.dark),
  },
}));
